import axios from './axios'

class PushRepository {
  subscribe (subscription) {
    return axios.post('/push-subscriptions', subscription).then((response) => {
      return response.data
    })
  }

  unsubscribe (endpoint) {
    return axios.delete('/push-subscriptions', { data: { endpoint: endpoint } }).then((response) => {
      return response.data
    })
  }

  getSubscriptions () {
    return axios.get('/push-subscriptions').then((response) => {
      return response.data
    })
  }
}

export default new PushRepository()



// WEBPACK FOOTER //
// ./src/data/push.repository.js